const routeConfig = [
	{ path: '/list', name: 'TransportauftragList', component: 'transportauftragList', useAsDefault: true},
    { path: '/create', name: 'TransportauftragCreate', component: 'transportauftragCreate'},
    { path: '/artikelUmbuchen', name: 'ArtikelUmbuchen', component: 'artikelUmbuchen'},
    { path: '/**', redirectTo: ['TransportauftragList']}
];

export default routeConfig;